export { SearchMappingAdmin } from "./SearchMappingAdmin";
